"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Api = _interopRequireWildcard(require("@/api/page"));
var _components = require("@/components");
var _page2 = require("@/common/enum/page");
var _permission = require("@/utils/permission");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var columns = [{
  title: '页面ID',
  dataIndex: 'page_id'
}, {
  title: '页面名称',
  dataIndex: 'page_name'
}, {
  title: '页面类型',
  dataIndex: 'page_type',
  scopedSlots: {
    customRender: 'page_type'
  }
}, {
  title: '添加时间',
  dataIndex: 'create_time'
}, {
  title: '更新时间',
  dataIndex: 'update_time'
}, {
  title: '操作',
  width: '180px',
  scopedSlots: {
    customRender: 'action'
  }
}];
var _default = exports.default = {
  name: 'Index',
  components: {
    STable: _components.STable
  },
  data: function data() {
    var _this = this;
    return {
      // 查询参数
      queryParam: {
        name: ''
      },
      // 枚举类
      PageTypeEnum: _page2.PageTypeEnum,
      // 正在加载
      isLoading: false,
      // 表头
      columns: columns,
      // 加载数据方法 必须为 Promise 对象
      loadData: function loadData(param) {
        return Api.list(_objectSpread(_objectSpread({}, param), _this.queryParam)).then(function (response) {
          var list = response && response.data && response.data.recordList ? response.data.recordList : [];
          return {
            data: list,
            current_page: Number(param.page) || 1,
            total: list.length
          };
        });
      }
    };
  },
  created: function created() {},
  methods: {
    hasPermission: function hasPermission(value) {
      return (0, _permission.checkPermi)(value);
    },
    // 新增页面
    handleAdd: function handleAdd() {
      this.$router.push('/content/page/create');
    },
    // 编辑页面
    handleEdit: function handleEdit(item) {
      this.$router.push({
        path: '/content/page/update',
        query: {
          pageId: item.page_id
        }
      });
    },
    // 设置为首页
    handleSetHome: function handleSetHome(item) {
      var app = this;
      var modal = this.$confirm({
        title: '您确定要设置为首页吗?',
        onOk: function onOk() {
          return Api.setHome({
            pageId: item.page_id
          }).then(function (result) {
            app.$message.success(result.message, 1.5);
            app.handleRefresh();
          }).finally(function (result) {
            modal.destroy();
          });
        }
      });
    },
    // 删除记录
    handleDelete: function handleDelete(item) {
      var app = this;
      var modal = this.$confirm({
        title: '您确定要删除该记录吗?',
        content: '删除后不可恢复',
        onOk: function onOk() {
          return Api.deleted({
            pageId: item.page_id
          }).then(function (result) {
            app.$message.success(result.message, 1.5);
            app.handleRefresh();
          }).finally(function (result) {
            modal.destroy();
          });
        }
      });
    },
    /**
     * 刷新列表
     * @param Boolean bool 强制刷新到第一页
     */
    handleRefresh: function handleRefresh() {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.$refs.table.refresh(bool);
    },
    /**
     * 检索查询
     */
    onSearch: function onSearch() {
      this.handleRefresh(true);
    }
  }
};